import type { Idea } from '../api'
import { setTheme, useTheme } from '../app/theme'
import { MoonIcon, SunIcon } from './icons'
import { SeriesFilter, seriesCounts } from './SeriesFilter'

/** The pipeline's title line, on the phone and over the canvas: the series filter and the theme. */
export function PipelineHead({ ideas }: { ideas: Idea[] }) {
  const theme = useTheme()
  return (
    <header className="pipeline-head">
      <h1 className="pipeline-title">Pipeline</h1>
      <SeriesFilter counts={seriesCounts(ideas)} />
      <button
        type="button"
        className="icon-button"
        aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      >
        {theme === 'dark' ? <SunIcon size={20} /> : <MoonIcon size={20} />}
      </button>
    </header>
  )
}
